// extracted by mini-css-extract-plugin
export default {"boton":"boton_boton__pmPhG","operador":"boton_operador__uQ3Ys"};